import { render, staticRenderFns } from "./vipLevels.vue?vue&type=template&id=6ef891b4&scoped=true"
import script from "./vipLevels.vue?vue&type=script&lang=js"
export * from "./vipLevels.vue?vue&type=script&lang=js"
import style0 from "./vipLevels.vue?vue&type=style&index=0&id=6ef891b4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ef891b4",
  null
  
)

export default component.exports